import React, {useContext} from "react";
import {AppContext} from "../../../components/AppProvider";
import {PostApi1704} from "../../../modules/network/padoPost";
import {closeLayerFn, openLayerFn} from "../../Layout";
import { socketManager, SocketCommand } from './../../../components/AppProvider';

export const DeleteLayer = (props) => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    const {deleteData, loadDataList, setDeleteState} = props;

    const deleteDataEvent = () => {
        if(deleteData.dataType === "P" && deleteData.procStat === "03") {
            // bizDtlType : 0 진료자료, 1 기타자료, 2 교육자료 , 3 제증명
            socketManager(SocketCommand.FILE_UPLOAD, undefined, {
                type: "delete",
                userToken: userinfo.userToken.toString(),
                masterKeys: [{ masterKey1: deleteData.seqNo.toString(), masterKey2: "", masterKey3: deleteData.refKey.toString()}],
    
                bizType: "PR",
                bizName: "진료자료",
                bizDtlType: "",
                viewYN: "N",
                saveExtYN: "N",
                redirectURL: "",
                colorType: "PP",
                hsptSharYn: "N",
                bizSubType: "0"
            });
        } else {
            socketManager(SocketCommand.FILE_UPLOAD, undefined, {
                type: "deleteItem",
                userToken: userinfo.userToken.toString(),
                masterKeys: [{ masterKey1: deleteData.seqNo.toString(), masterKey2: "", masterKey3: deleteData.refKey.toString()}],
        
                bizType: "PR",
                bizName: "진료자료",
                bizDtlType: "",
                viewYN: "N",
                saveExtYN: "N",
                redirectURL: "",
                colorType: "PP",
                hsptSharYn: "N",
                bizSubType: "0"
            });
        }
        
    }

    return (
        <div className="blacklayer-container delete-confirm-layer">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical priv">
                        <div className="blgr-title">삭제</div>

                        <div className="delete-confirm-box">
                            <p>진료자료를 삭제 하겠습니까?</p>
                        </div>

                        <div className="tbns-area">
                            <a
                                onClick={() => closeLayerFn($(".delete-confirm-layer"))}
                                className="btn-round gray">
                                취소
                            </a>
                            <a onClick={() => deleteDataEvent()} className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};